import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import MainRoutes from "./routes/mainRoutes"; // Assuming MainRoutes is a component
import AdminRoutes from "./admin/routes/AdminRoutes"; // Assuming AdminRoutes is a component
import LoginPage from "./admin/pages/LoginPage";

import { isAdminAuthenticated, isUserAuthenticated } from "./utils/auth";
import MainUserRoutes from "./routes/userRoutes";
import UserLogin from "./users/pages/UserLoginPage";
import { useEffect } from "react";

import { requestFCMToken } from "./utils/FirebaseUtils";
import { useState } from "react";
import axios from "axios";
import BASE_URL from "./config/apiConfig";
import Layout from "./layout";
import CuppatradeRedirect from "./users/pages/Auth/CuppatradeRedirect";
import CuppatradeLogin from "./users/pages/Auth/CuppatradeLogin";
import CuppatradeSignup from "./users/pages/Auth/CuppatradeSignUp";
import Chatbot from "./components/Chatbot/Chatbot";

const ProtectedRoute = ({ element }) => {
  return isAdminAuthenticated() ? element : <Navigate to="/admin/login" />;
};

export default function App() {
  const [fcmToken, setFcmToken] = useState(null);

  useEffect(() => {
    const fetchFCMToken = async () => {
      try {
        const token = await requestFCMToken();
        if (token !== fcmToken) {
          // Avoid duplicate token submission
          setFcmToken(token);
          await axios.post(`${BASE_URL}/api/devices`, { token });
          console.log("Token: ", token);
        }
      } catch (error) {
        console.error("Error during FCM token fetch: ", error);
      }
    };
    fetchFCMToken();
  }, []);

  return (
    <div className="App">
      <Router>
        <Chatbot />
        <Routes>
          {/* Admin Login Route */}
          <Route
            path="/admin/login"
            element={
              isAdminAuthenticated() ? (
                <Navigate to="/admin/dashboard" />
              ) : (
                <LoginPage />
              )
            }
          />

          {/* Admin Protected Routes */}
          <Route
            path="/admin/*"
            element={<ProtectedRoute element={<AdminRoutes />} />}
          />

          {/* Main Routes */}
          <Route path="/*" element={<MainRoutes />} />

          {/* User Login Route */}
          <Route
            path="/user/login"
            element={
              isUserAuthenticated() ? (
                <Navigate to="/user/home" />
              ) : (
                <Layout>
                  <UserLogin />
                </Layout>
              )
            }
          />

          {/* User Routes */}
          <Route path="/user/*" element={<MainUserRoutes />} />
          <Route path="/cuppatrade" element={<CuppatradeRedirect />} />
          <Route path="/cuppatrade/login" element={<CuppatradeLogin />} />
          <Route path="/cuppatrade/signup" element={<CuppatradeSignup />} />
        </Routes>
      </Router>
    </div>
  );
}
